"use client";
import { useState } from "react";
import { AuthModal } from "@/components/auth/auth-modal";

export function useCartAuthGate() {
  const [open, setOpen] = useState(false);
  const [pendingPayload, setPendingPayload] = useState<{ payload: unknown; onSuccess: () => void } | null>(null);

  function requireAuth(payload: unknown, onSuccess: () => void) {
    setPendingPayload({ payload, onSuccess });
    setOpen(true);
  }

  function handleSuccess() {
    if (pendingPayload) {
      pendingPayload.onSuccess();
      setPendingPayload(null);
    }
    setOpen(false);
  }

  function handleClose() {
    setOpen(false);
    setPendingPayload(null);
  }

  const modal = (
    <AuthModal isOpen={open} onClose={handleClose} onSuccess={handleSuccess} />
  );

  return { requireAuth, modal };
}
